/*
 *  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
 *  ~ No part of this publication may be reproduced, distributed,
 *  ~ or transmitted in any form or by any means, including photocopying, recording,
 *  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
 *  ~ except in the case of brief quotations embodied in critical
 *  ~ reviews and certain other noncommercial uses permitted by copyright law.
 *  ~ Author : BS
 *  ~ Date : 4/26/23, 4:46 PM
 */

import { SerializedVigiCrudAuthorizationInterface } from '../../../../interface/serialized/serialized-vigi-crud-authorization.interface';

export class CrudAuthorization {
  public creation: string[];
  public read: string[];
  public update: string[];
  public delete: string[];

  serialize(): SerializedVigiCrudAuthorizationInterface {
    let data = {};
    if (this.creation && this.creation.length > 0) {
      data = { ...data, ...{ creation: this.creation } };
    }
    if (this.read && this.read.length > 0) {
      data = { ...data, ...{ read: this.read } };
    }
    if (this.update && this.update.length > 0) {
      data = { ...data, ...{ update: this.update } };
    }
    if (this.delete && this.delete.length > 0) {
      data = { ...data, ...{ delete: this.delete } };
    }
    return Object.keys(data).length === 0 ? null : data;
  }
}
